import React, { useState } from "react";
import ColorSearch from "./ColorSearch";
import ImageSearch from "./ImageSearch";
import "./selector.css";

function SelectInput() {
  const [activeComponent, setActiveComponent] = useState(null);

  const handleColorClick = () => {
    setActiveComponent("color");
  };

  const handleImageClick = () => {
    setActiveComponent("image");
  };

  const handleBack = () => {
    setActiveComponent(null);
  };

  if (activeComponent === "color") {
    return <ColorSearch onBack={handleBack} />;
  }

  if (activeComponent === "image") {
    return <ImageSearch onBack={handleBack} />;
  }

  return (
    <div>
      <h2>Search By:</h2>
      <div className="HorizontalDiv">
        <div className="Color" onClick={handleColorClick}>
          <p className="text">Color</p>
        </div>
        <div className="Image" onClick={handleImageClick}>
          <div className="Image-overlay">
            <p className="text">Image</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectInput;